<template>
	<landing-page-template1 />
</template>

<script>
import LandingPageTemplate1 from '@/views/JnsLandingPages/templates/LandingPageTemplate1.vue';

export default {
	name: 'RevitaBluLandingPage',
	components: { LandingPageTemplate1 },
};
</script>

<style scoped>

</style>
